import moment from "moment/moment";
import {GlobalStyleAttributes} from "../../../../shared/styles/GlobalStyles";
import SharedTimepicker from "../../../../shared/components/common/SharedTimepicker";
import React, {useEffect} from "react";
import {VStack} from "native-base";
import FormInput from "../../../../shared/components/common/FormInput";
import {t} from "../../../../shared/services/i18n";
import {dbDateFormat, isMobile} from "../../../../shared/services/Helpers";
import {checkRequired} from "../../../../shared/services/stepperService";
import AppText from "../../../../shared/components/common/AppText";
import CustomCheckbox from "../../../../shared/components/common/CustomCheckbox";
import {flowOptions} from "../../../../shared/components/Structure/Schedule/Popups/CreateEvent/FlowOptions";
import {Colors} from "../../../../shared/styles/Colors";


const SendInvoicesReport = (props) => {
    const {setFieldValue, values, touched, errors, validationObject, handleChange } = props

    return (
        <VStack space={'1.5rem'}>
            <VStack space={'0.5rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('export-as')+"*"}</AppText>
                <CustomCheckbox isChecked={values.csv} onChange={val => setFieldValue('csv', val)} text={t('csv-option')}/>
                <CustomCheckbox isChecked={values.pdf} onChange={val => setFieldValue('pdf', val)} text={t('pdf-option')}/>
                {errors.csv && <AppText color={Colors.error} fontSize={GlobalStyleAttributes.fonts.infoText} width='max-content' mediumFont>
                    {errors.csv}
                </AppText>}
            </VStack>
            <FormInput
                infoTooltip={t('send-to-mail-info')}
                label={t('send-to-email')+checkRequired('email', validationObject)}
                value={values.email}
                name={'email'}
                onChangeCallback={handleChange('email')}
                error={(touched.email && errors.email) ? errors.email : null}
                containerProps={{ mb: 0 }}
                width={'100%'}
                type='email'
                placeholder={t('your-accountant-email')}
            />
            <FormInput
                infoTooltip={t('bcc-info')}
                label={t('bcc')}
                value={values.bcc}
                name={'bcc'}
                onChangeCallback={handleChange('bcc')}
                error={(touched.bcc && errors.bcc) ? errors.bcc : null}
                containerProps={{ mb: 0 }}
                width={'100%'}
                type='email'
                placeholder={t('your-email')}
            />
        </VStack>

    )
}

export default SendInvoicesReport